"use client";
import { useState } from "react";
import { useRouter } from "next/navigation";
import Image from "next/image";
import { authService } from "@/services/authService";

export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const router = useRouter();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = await authService.login({ username, password });
      localStorage.setItem('@LucianoSystem:token', data.access);
      router.push("/dashboard"); 
    } catch (err) {
      console.error("Erro no login:", err);
      alert("Erro ao logar. Verifique suas credenciais.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="relative flex min-h-screen items-center justify-center p-4 bg-black overflow-hidden">
      
      {/* Container da Imagem Contida */}
      <div className="absolute inset-0 z-0 flex items-center justify-center">
        <Image
          src="/login-bg.png"
          alt="Range360 Logo Background"
          fill 
          priority 
          className="object-contain opacity-50 z-0"
          quality={100}
        />
      </div>

      <div className="glass-card relative z-10 w-full max-w-md p-8 animate-in zoom-in duration-300">
        <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-white tracking-tight">Range360</h1>
            <p className="text-gray-300 text-sm">Painel de Monitoramento Institucional</p>
        </div>
        
        <form onSubmit={handleLogin} className="flex flex-col gap-4">
          <div className="flex flex-col gap-1">
            <label className="text-xs text-gray-400 ml-1">USUÁRIO</label>
            <input 
              type="text" 
              placeholder="Digite seu usuário..." 
              className="glass-input text-white w-full" 
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className="flex flex-col gap-1">
            <label className="text-xs text-gray-400 ml-1">SENHA</label>
            <input 
              type="password" 
              placeholder="••••••••" 
              className="glass-input text-white w-full" 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button 
            type="submit" 
            disabled={loading}
            className="btn-primary mt-4 py-3 disabled:opacity-50 transition-all transform active:scale-95"
          >
            {loading ? "Autenticando..." : "ACESSAR SISTEMA"}
          </button>
        </form>
      </div>

      <p className="absolute bottom-4 text-center z-10 text-xs text-gray-500">
          &copy; 2026 Range360
      </p>

    </main>
  );
}